import { FC, useMemo } from 'react';
import {
  IGeneralData,
  IorderProductsData,
  IShipmentData
} from '../../../../../../../types/orders';
import ShipmentCardTracking from '../ShipmentCard/ShipmentCardTracking';
import { buildOrderedCardsForTracking } from '../../../../../../../utils/groupShipmentsByDestinationAndStatus';
import './ShipmentDetailsCard.scss';

interface IShipmentDetailsCard {
  isEnabled: boolean;
  updateWithoutLoaders: () => Promise<void>;
  updateWithLoaders: () => Promise<void>;
  generalData: IGeneralData;
  listOfGroupedShipments?: IShipmentData[];
  orderId?: string;
  listProducts?: IorderProductsData;
}

const ShipmentDetailsCard: FC<IShipmentDetailsCard> = ({
  isEnabled,
  updateWithoutLoaders,
  updateWithLoaders,
  generalData,
  listOfGroupedShipments,
  orderId,
  listProducts
}) => {
  const numericOrderId = useMemo(
    () => (orderId ? Number(orderId) : undefined),
    [orderId]
  );

  const references = useMemo(() => {
    if (!listProducts) return undefined;
    const firstProduct = Object.values(listProducts)[0];
    return firstProduct?.references;
  }, [listProducts]);

  const orderedCardsForTracking = useMemo(() => {
    if (!listOfGroupedShipments?.length) return [];
    return buildOrderedCardsForTracking(listOfGroupedShipments);
  }, [listOfGroupedShipments]);

  if (!listOfGroupedShipments?.length) return null;

  return (
    <div id="shipmentDetailsCard">
      <div className="containerSections">
        <div className="w-full">
          {orderedCardsForTracking.map((card, cardIndex) => (
            <ShipmentCardTracking
              key={`tracking-${card.completeDataForEachGroupOfShipments.shipmentId}-${card.productGroupIndex}`}
              listOfGroupedShipments={listOfGroupedShipments}
              productsInShippingGroup={card.productsInShippingGroup}
              completeDataForEachGroupOfShipments={
                card.completeDataForEachGroupOfShipments
              }
              isEnabled={isEnabled}
              index={card.shipmentIndex}
              orderId={numericOrderId ?? 0}
              generalData={generalData}
              updateWithoutLoaders={updateWithoutLoaders}
              updateWithLoaders={updateWithLoaders}
              references={references ?? []}
              optionalShipmentTitle={card.optionalShipmentTitle}
              isLastCardInRenderedList={
                cardIndex === orderedCardsForTracking.length - 1
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShipmentDetailsCard;
